document.querySelectorAll('.footer__block--links .h6').forEach(function(header) {
    header.addEventListener('click', function() {
      // Alterna la clase 'open' en el bloque actual
      this.parentElement.parentElement.classList.toggle('open');
    });
});